<main class="min-h-dvh flex items-center justify-center p-4">
  <a class="text-[#007DCB] underline" [href]="pdfUrl">{{ 'profile.termsAndConditions' | translate }}</a>
</main>
